import { render, staticRenderFns } from "./PrintingComponent.vue?vue&type=template&id=23755f74"
import script from "./PrintingComponent.vue?vue&type=script&lang=js"
export * from "./PrintingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports